import { FC } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './Loader.module.sass';

type LoaderSize = 'small' | 'medium' | 'large' | 'x_small';

interface LoaderProps {
  size?: LoaderSize;
}

const Loader: FC<LoaderProps> = (props) => {
  const { size } = props;

  let fontSize = 50;

  if (size === 'small') {
    fontSize = 25;
  } else if (size === 'large') {
    fontSize = 75;
  } else if (size === 'x_small') {
    fontSize = 16;
  }

  return (
    <div className={styles.loader}>
      <LoadingOutlined spin style={{ fontSize }} />
    </div>
  );
};

Loader.defaultProps = {
  size: 'medium',
};

export default Loader;
